import { Banner, Text } from '@dixa/lib-shared-habla';

export const PartnerIntegrationsWidgetError = (): JSX.Element => {
  return (
    <Banner
      variant="warning"
      description={
        <Text.Paragraph as="span" variant="4">
          Something went wrong. Either the requested widget does not exist or
          there is no ID in the URL.
        </Text.Paragraph>
      }
    />
  );
};
